// Absolute wake-order positions on the official combined night-order sheet, generated from
// first_night.md / other_night.md in the old botc-townsquare repo. Keyed by data.ts's toId()
// (lowercase a-z0-9), so entries line up with BASE_CHARACTERS.
//
// A superset of NIGHT_ACTIONS: it also covers information-only characters, since it only drives the
// reference wake order. A character absent from an object doesn't wake that night (the Imp has no
// firstNight entry).
//
// Travelers were missing from that source; their fractional positions follow the official
// botc-release nightsheet.json.
export const FIRST_NIGHT_ORDER = {
    wraith: 1,
    lordoftyphon: 2,
    kazali: 3,
    apprentice: 3.2,
    barista: 3.4,
    bureaucrat: 3.6,
    thief: 3.8,
    boffin: 4,
    philosopher: 5,
    alchemist: 6,
    poppygrower: 7,
    yaggababble: 8,
    magician: 9,
    snitch: 11,
    lunatic: 12,
    summoner: 13,
    king: 15,
    sailor: 16,
    marionette: 17,
    engineer: 18,
    preacher: 19,
    lilmonsta: 20,
    lleech: 21,
    xaan: 22,
    poisoner: 23,
    widow: 24,
    courtier: 25,
    wizard: 26,
    snakecharmer: 27,
    godfather: 28,
    organgrinder: 29,
    devilsadvocate: 30,
    eviltwin: 31,
    witch: 32,
    cerenovus: 33,
    fearmonger: 34,
    harpy: 35,
    mezepheles: 36,
    pukka: 37,
    pixie: 38,
    huntsman: 39,
    damsel: 40,
    amnesiac: 41,
    washerwoman: 42,
    librarian: 43,
    investigator: 44,
    chef: 45,
    empath: 46,
    fortuneteller: 47,
    butler: 48,
    grandmother: 49,
    clockmaker: 50,
    dreamer: 51,
    seamstress: 52,
    steward: 53,
    knight: 54,
    noble: 55,
    balloonist: 56,
    shugenja: 57,
    villageidiot: 58,
    bountyhunter: 59,
    nightwatchman: 60,
    cultleader: 61,
    spy: 62,
    ogre: 63,
    highpriestess: 64,
    general: 65,
    chambermaid: 66,
    mathematician: 67,
    leviathan: 69,
    vizier: 70,
};
/**
 * Characters whose night entry still matters once the holder is dead: they act or are resolved
 * because they died (Ravenkeeper wakes after dying; the Storyteller applies the rest). Any other dead
 * holder has nothing to do tonight.
 */
const ACTS_WHEN_DEAD = new Set([
    "ravenkeeper", "sage", "sweetheart", "barber", "hatter", "plaguedoctor", "banshee", "choirboy",
    "farmer", "moonchild",
]);
/** A dead holder whose character has no ability to use dead: shown greyed out, never prompted. */
export function isDormant(seat, characterId) {
    return !seat.alive && !ACTS_WHEN_DEAD.has(characterId);
}
export const OTHER_NIGHT_ORDER = {
    wraith: 1,
    cacklejack: 1.1,
    barista: 1.2,
    bureaucrat: 1.3,
    thief: 1.4,
    harlot: 1.5,
    bonecollector: 1.6,
    philosopher: 2,
    poppygrower: 3,
    sailor: 4,
    engineer: 5,
    preacher: 6,
    xaan: 7,
    poisoner: 8,
    courtier: 9,
    innkeeper: 10,
    wizard: 11,
    gambler: 12,
    acrobat: 13,
    snakecharmer: 14,
    monk: 15,
    organgrinder: 16,
    devilsadvocate: 17,
    witch: 18,
    cerenovus: 19,
    pithag: 20,
    fearmonger: 21,
    harpy: 22,
    mezepheles: 23,
    scarletwoman: 24,
    summoner: 25,
    lunatic: 26,
    exorcist: 27,
    lycanthrope: 28,
    princess: 29,
    legion: 30,
    imp: 31,
    zombuul: 32,
    pukka: 33,
    shabaloth: 34,
    po: 35,
    fanggu: 36,
    nodashii: 37,
    vortox: 38,
    lordoftyphon: 39,
    vigormortis: 40,
    ojo: 41,
    alhadikhia: 42,
    lleech: 43,
    lilmonsta: 44,
    yaggababble: 45,
    kazali: 46,
    assassin: 47,
    godfather: 48,
    gossip: 49,
    hatter: 50,
    barber: 51,
    sweetheart: 52,
    plaguedoctor: 53,
    sage: 54,
    banshee: 55,
    professor: 56,
    choirboy: 57,
    huntsman: 58,
    damsel: 59,
    amnesiac: 60,
    farmer: 61,
    tinker: 62,
    moonchild: 63,
    grandmother: 64,
    ravenkeeper: 65,
    empath: 66,
    fortuneteller: 67,
    undertaker: 68,
    dreamer: 69,
    flowergirl: 70,
    towncrier: 71,
    oracle: 72,
    seamstress: 73,
    juggler: 74,
    balloonist: 75,
    villageidiot: 76,
    king: 77,
    bountyhunter: 78,
    nightwatchman: 79,
    cultleader: 80,
    butler: 81,
    spy: 82,
    highpriestess: 83,
    general: 84,
    chambermaid: 85,
    mathematician: 86,
    riot: 87,
    leviathan: 89,
};
//# sourceMappingURL=nightOrder.js.map